/** The fields pickOrganization needs (useOrganization's Organization has them). */
export interface PickableOrganization {
  id: string;
  role: "owner" | "admin" | "member";
}

/**
 * Which company to open: the one this person used last, else (legacy) the one
 * last used in this browser, else the first they own, else the first at all.
 */
export function pickOrganization<T extends PickableOrganization>(
  organizations: T[],
  preferredIds: (string | null)[]
): T | null {
  for (const id of preferredIds) {
    const hit = id ? organizations.find((o) => o.id === id) : undefined;
    if (hit) return hit;
  }
  return organizations.find((o) => o.role === "owner") ?? organizations[0] ?? null;
}
